var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateTroubleTicketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yidqda1fia)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uyd22rpvsb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.348 7.28c2.08-2.34 5.2-3.758 6.8-3.232.36.118.473.53.375.896l-1.734 6.435a1 1 0 0 0 .301 1.008l1.717 1.526a1 1 0 0 0 1.036.18l6.188-2.473c.351-.141.774-.077.934.266.71 1.529-.334 4.792-2.415 7.133-2.506 2.818-5.661 3.982-9.228 3.224-.37-.079-.76.034-1.012.317L12.809 36.62c-1.174 1.32-2.348 2.64-4.988.293-2.64-2.347-1.467-3.668-.293-4.988l12.501-14.06c.252-.283.318-.683.196-1.042-1.17-3.454-.383-6.724 2.123-9.542z",
    stroke: "url(#fv8voe133c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.44 14.94-2.373-1.981a1 1 0 0 1-.323-1.036l1.628-5.858c.244-.881-.724-1.602-1.497-1.114l-5.29 3.338-1.756 4.256.462 4.811L6.934 32.843a2 2 0 0 0 .233 2.841l1.98 1.654a2 2 0 0 0 2.738-.163l14.225-15.1h6.095l4.064-3.885 1.367-4.173a1 1 0 0 0-1.318-1.24l-5.869 2.325a1 1 0 0 1-1.01-.162z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yidqda1fia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uyd22rpvsb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv8voe133c",
    x1: -2.818,
    y1: 55.313,
    x2: -15.481,
    y2: 39.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateTroubleTicketIcon);
export default __webpack_public_path__ + "static/media/corporateTroubleTicketIcon.a51d997ae1fe0877fb88e35c23d0453c.svg";
export { ForwardRef as ReactComponent };